<script>
export default {
    name: 'InjectHtml',
    props: {
        html: { type: String, required: true },
        location: {
            type: String,
            default: 'head',
            validator: v => ['head', 'body'].includes(v),
        },
        blockKey: { type: [String, Number], required: true },
    },
    data() {
        return {
            injectedIds: [],
        }
    },
    mounted() {
        this.injectHtml()
    },
    beforeDestroy() {
        this.cleanAllTracking()
    },
    methods: {
        cleanAllTracking() {
            // Limpia todo lo que pueda haber quedado de cualquier pixel (de cualquier evento/cliente)
            const selectors = [
                // Facebook, Google, TikTok (puedes añadir más dominios)
                'script[src*="facebook"]',
                'script[src*="google"]',
                'script[src*="tiktok"]',
                'iframe[src*="facebook"]',
                'iframe[src*="google"]',
                'iframe[src*="tiktok"]',
                'img[src*="facebook"]',
                'img[src*="google"]',
                'img[src*="tiktok"]',
                // Todo lo que este propio componente haya inyectado
                '[data-injected-by="inject-html"]',
            ]
            document.querySelectorAll(selectors.join(',')).forEach(el => {
                el.parentNode && el.parentNode.removeChild(el)
            })
            this.injectedIds = []
        },

        injectHtml() {
            this.cleanAllTracking()
            if (!this.html) return
            const container = document.createElement('div')
            container.innerHTML = this.html
            let counter = 0
            Array.from(container.childNodes).forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    counter++
                    const tagId = `inject-${this.blockKey}-${this.location}-${counter}-${Date.now()}`
                    let toInject
                    if (node.nodeName === 'SCRIPT') {
                        toInject = document.createElement('script')
                        for (let attr of node.attributes) {
                            toInject.setAttribute(attr.name, attr.value)
                        }
                        if (!toInject.src && (node.innerHTML || node.textContent)) {
                            toInject.text = node.innerHTML || node.textContent
                        }
                    } else {
                        toInject = node.cloneNode(true)
                    }
                    toInject.id = tagId
                    toInject.setAttribute('data-injected-by', 'inject-html')
                    if (this.location === 'head') {
                        document.head.appendChild(toInject)
                    } else {
                        document.body.appendChild(toInject)
                    }
                    this.injectedIds.push(tagId)
                }
            })
        },
    },
    render() {
        return null
    },
}
</script>
